import {
  currencyCodeToLocales
} from '../../../app/data/currencies';

export function countCharacterAfterMatchingCase(
  format: string,
  matchStr = 'E+',
  passingCase = '0'
) {
  const index = format.indexOf(matchStr);
  if (index === -1) return 0;

  const startIndex = index + matchStr.length;

  let count = 0;
  for (let i = startIndex; i < format.length; i++) {
    const c = format.charAt(i);
    if (passingCase.includes(c)) {
      count++;
    } else {
      break;
    }
  }

  return count;
}

export const getCurrenySymbolFromCode = (currencyCode: string) => {
  const locale = currencyCodeToLocales[currencyCode];
  // const locale = localesToCurrency.get(currencyCode);
  if (!currencyCode) return '';
  let symbol =
    currencyCode === 'none'
      ? ''
      : Number('')
          .toLocaleString(locale, {
            style: 'currency',
            currency: currencyCode,
            currencyDisplay: 'narrowSymbol',
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
            useGrouping: true,
            // signDisplay: "always"
          })
          .replace(/\d/g, '')
          .trim();

  symbol =
    symbol[symbol.length] === '۰'
      ? symbol.substring(0, symbol.length - 1)
      : symbol;

  return symbol;
};

// interface CreateFormatCodeConfigs {
//   decimalPlaces: number;
//   thousandSeparator: number;
//   negativeFormatType: NegativeNumFormatType;
//   symbol: string;
//   currencyCode: string;
// }
// export const createFormatCode = (configs: Partial<CreateFormatCodeConfigs>) => {
//   let formatCode = '###0';
//   if (configs.thousandSeparator) {
//     formatCode = '#,##0';
//   }

//   if (configs.decimalPlaces && configs.decimalPlaces > 0) {
//     formatCode += '.' + '0'.repeat(configs.decimalPlaces);
//   }

//   if (configs.symbol) formatCode += configs.symbol;

//   if (
//     configs.negativeFormatType ===
//       NegativeNumFormatType.NegativeInBrackets ||
//     configs.negativeFormatType ===
//       NegativeNumFormatType.NegativeAsRedInBrackets
//   ) {
//     formatCode = '(' + formatCode + ')';
//   }

//   return formatCode;
// };
